import styled from 'styled-components';

export const TableScheduleCellRemoveStyled = styled.figure`
    display: grid;
    justify-content: end;
    cursor: pointer;
`;
